import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material'

// Show the message once loading has taken longer than this. Measured from page
// navigation start (performance.now()), matching how total_load_time_ms is
// defined for the diagnostic event, so it survives Splash remounts across the
// loading flow rather than restarting each time.
const SLOW_LOAD_THRESHOLD_MS = 10000

const Message = styled('div')({
    position: 'absolute',
    bottom: '200px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'calc(100% - 56px)',
    maxWidth: 320,
    backgroundColor: 'rgba(44, 44, 48, 0.55)',
    backdropFilter: 'blur(14px)',
    WebkitBackdropFilter: 'blur(14px)',
    border: '1px solid rgba(255, 255, 255, 0.16)',
    color: 'white',
    borderRadius: 18,
    padding: '16px 20px',
    fontFamily:
        '-apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 1.45,
    textAlign: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
    zIndex: 10,
})

function SlowConnectionMessage() {
    const [show, setShow] = useState(
        () => performance.now() >= SLOW_LOAD_THRESHOLD_MS
    )

    useEffect(() => {
        if (show) return undefined
        const remaining = SLOW_LOAD_THRESHOLD_MS - performance.now()
        if (remaining <= 0) {
            setShow(true)
            return undefined
        }
        const timer = setTimeout(() => setShow(true), remaining)
        return () => clearTimeout(timer)
    }, [show])

    if (!show) return null

    return (
        <Message role="status">
            Looks like you may not have the greatest connection. Please hang in
            there while we load your experience.
        </Message>
    )
}

export { SlowConnectionMessage }
